import React, {useEffect, useState, useRef} from 'react';
import models from "../../network/models/quick_models";
import deliveryService from "../../network/services/delivery";
import formatter from "../../helpers/number_formatter";
import helper from '../../helpers/general_helper';
import usePlacesAutocomplete, {getGeocode, getLatLng} from 'use-places-autocomplete';
import useOnclickOutside from 'react-cool-onclickoutside';
import toastifyHelper from "../../helpers/toastify_helper";
import {getUserName, getUserPhoneNumber} from "../../helpers/authenticator";
import {useForm} from "react-hook-form";


const OrderLocationForm = ({change}) => {
    const [formState, setFormState] = useState(false);
    const [pickUp, setPickUp] = useState({});
    const [dropOff, setDropOff] = useState({});
    const [deliveryQuoteResponse, setDeliveryQuote] = useState({});

    const {register, handleSubmit, watch, errors} = useForm();
    const [isDropOffSet, setIsDropOffSet] = useState(false);
    const [isPickUpSet, setIsPickUpSet] = useState(false);


    const pickUpInstance = usePlacesAutocomplete({
        requestOptions: {componentRestrictions: {country: 'gh'}},
        debounce: 100
    });

    const dropOffInstance = usePlacesAutocomplete({
        requestOptions: {componentRestrictions: {country: 'gh'}},
        debounce: 100
    });

    const instance = {pick_up: pickUpInstance, drop_off: dropOffInstance};


    const ref = useRef();
    useOnclickOutside(ref, () => {
        // When user clicks outside of the component, we can dismiss
        // the searched suggestions by calling this method
        // clearSuggestions();
    });

    const handlePickUpInput = e => {
        // Update the keyword of the input element
        instance.pick_up.setValue(e.target.value);
    };

    const handleDropOffInput = e => {
        instance.drop_off.setValue(e.target.value);
    };

    const handleSelect = ({suggestion, type}) => () => {
        // When user selects a place, we can replace the keyword without request data from API
        // by setting the second parameter as "false"
        // setValue(description, false);
        // clearSuggestions();

        switch (type) {
            case "pick_up":
                instance.pick_up.setValue(suggestion.structured_formatting.main_text, false);
                instance.pick_up.clearSuggestions();
                setIsPickUpSet(false);
                break;
            case "drop_off":
                instance.drop_off.setValue(suggestion.structured_formatting.main_text, false);
                instance.drop_off.clearSuggestions();
                setIsDropOffSet(false);
                break;
            default:

        }


        // Get latitude and longitude via utility functions
        getGeocode({address: suggestion.description})
            .then(results => getLatLng(results[0]))
            .then(({lat, lng}) => {
                setQuoteValues({
                    address: suggestion.structured_formatting.main_text,
                    latitude: lat,
                    longitude: lng
                }, type)
            }).catch(error => {
            console.log('😱 Error: ', error)
        });

    };

    const setQuoteValues = (data, type) => {
        switch (type) {
            case "pick_up":
                setPickUp(data);
                setIsPickUpSet(true);
                break;
            case "drop_off":
                setDropOff(data);
                setIsDropOffSet(true);
                break;
            default:
        }
    };

    const renderPickUpSuggestions = () =>
        instance.pick_up.suggestions.data.map(suggestion => {
            const {
                id,
                structured_formatting: {main_text, secondary_text}
            } = suggestion;

            return (
                <li
                    key={id}
                    onClick={handleSelect({suggestion: suggestion, type: "pick_up"})}
                    id={"ex-list-item-" + id}
                    className="css-105dbyq-listItem-listItem"
                ><strong>{main_text}</strong> <small className="css-vw2eqe-subText">{secondary_text}</small></li>
            );
        });

    const renderDropOffSuggestions = () =>
        instance.drop_off.suggestions.data.map(suggestion => {
            const {
                id,
                structured_formatting: {main_text, secondary_text}
            } = suggestion;

            return (
                <li
                    key={id}
                    onClick={handleSelect({suggestion: suggestion, type: "drop_off"})}
                    id={"ex-list-item-" + id}
                    className="css-105dbyq-listItem-listItem"
                ><strong>{main_text}</strong> <small className="css-vw2eqe-subText">{secondary_text}</small></li>
            );
        });


    const bringFocus = () => {
        setFormState(false);
    };

    const submitForm = () => {

        let data = models.deliveryRequest;
        data.drop_off = dropOff;
        data.pick_up = pickUp;

        if (pickUp !== '' && dropOff !== '') {
            deliveryService.quote(data).then(response => {
                setFormState(true);
                setDeliveryQuote(response.data);
                updateDeliveryData(response.data)
            }).catch(error => {
                toastifyHelper.toastify.errorToastify(error.response.data.message);
                console.log(error.response);
            });
        } else {
            // setFormErrors(true)
        }

    };


    const updateDeliveryData = (data) => {
        let formedData = models.createDeliveryOrderResponse;
        if (!helper.isEmpty(data)) {
            let merged = {...models.deliveryQuoteResponse, ...data.data};

            formedData.pick_up.address = merged.pick_up.address;
            formedData.pick_up.latitude = merged.pick_up.latitude;
            formedData.pick_up.longitude = merged.pick_up.longitude;

            formedData.pick_up.name = getUserName();
            formedData.pick_up.phone_number = getUserPhoneNumber();
            formedData.pick_up.image_url = "";

            formedData.drop_off.address = merged.drop_off.address;
            formedData.drop_off.latitude = merged.drop_off.latitude;
            formedData.drop_off.longitude = merged.drop_off.longitude;

            formedData.quote.fee = merged.fee;
            formedData.quote.currency = merged.currency;
            formedData.quote.duration = merged.duration;
            formedData.quote.duration_unit = merged.duration_unit;
        } else {

        }
        change.callback({
            state: true,
            componentType: "location-form",
            componentSubType: "deliveries",
            deliveryOrder: formedData
        })
    };


    const showButtonType = () => {
        if (formState) {
            return (
                <button className="btn btn-primary btn-md" onClick={() => {
                    change.callback({
                        state: true,
                        componentType: "client-form",
                        componentSubType: "delivery-quote",
                        deliveryOrder: models.createDeliveryRequest
                    })
                }}>
                    Next
                </button>
            )
        } else {
            return (
                <button className="btn btn-primary btn-md" disabled={!isPickUpSet && !isDropOffSet}>
                    Get Quote
                </button>
            )
        }
    };

    let deliveryQuote = {...models.deliveryQuoteResponse, ...deliveryQuoteResponse.data};
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-wrapper">
                            <form onSubmit={handleSubmit(submitForm)} autoComplete="off">
                                <ul className="list-unstyled">
                                    <li>
                                        <h1>{deliveryQuote.currency.toUpperCase() +
                                        formatter.accounting.formatMoney(deliveryQuote.fee, "¢")}</h1>
                                        <p>It will take about {
                                            deliveryQuote.duration
                                            + " " + deliveryQuote.duration_unit}</p>
                                    </li>
                                    <li style={{marginTop: 15}}>
                                        <div ref={ref} className="input-group">
                                            <input type="text"
                                                   className="form-control pick_up_icon form-control-lg input-form-alt"
                                                   placeholder="Where is your item going?"
                                                   disabled={!instance.pick_up.ready}
                                                   name="pick_up"
                                                   autoComplete="off"
                                                   value={instance.pick_up.value}
                                                   ref={register({required: true})}
                                                   onFocus={bringFocus}
                                                   onChange={handlePickUpInput} onPaste={handlePickUpInput}
                                                   aria-label="Username" aria-describedby="basic-addon1"
                                            />

                                            {instance.pick_up.suggestions.status === 'OK' &&
                                            <ul id="ex-list-box" role="listbox"
                                                className="css-9ta5em-listBox">{renderPickUpSuggestions()}</ul>}
                                        </div>
                                    </li>
                                    <li>
                                        {errors.pick_up &&
                                        <small className="small-text-red"> <i
                                            className="fas fa-exclamation-triangle"></i> This field is
                                            required</small>}
                                    </li>
                                    <li style={{marginTop: 15}}>
                                        <div ref={ref} className="input-group">
                                            <input type="text"
                                                   name="drop_off"
                                                   className="form-control drop_off_icon form-control-lg input-form-alt"
                                                   placeholder="Where is your item?"
                                                   autoComplete="off"
                                                   disabled={!instance.drop_off.ready}
                                                   value={instance.drop_off.value}
                                                   ref={register({required: true})}
                                                   onFocus={bringFocus}
                                                   onChange={handleDropOffInput} onPaste={handleDropOffInput}
                                                   aria-label="Username" aria-describedby="basic-addon1"
                                            />
                                            {/*/!* We can use the "status" to decide whether we should display the dropdown or not *!/*/}
                                            {instance.drop_off.suggestions.status === 'OK' &&
                                            <ul id="ex-list-box" role="listbox"
                                                className="css-9ta5em-listBox">{renderDropOffSuggestions()}</ul>}
                                        </div>
                                    </li>
                                    <li>
                                        {errors.drop_off &&
                                        <small className="small-text-red"> <i
                                            className="fas fa-exclamation-triangle"></i> This field is
                                            required</small>}
                                    </li>
                                    <li>
                                        <br/>
                                    </li>
                                    <li className="text-right">
                                        {showButtonType()}
                                    </li>
                                </ul>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default OrderLocationForm;
